export default __webpack_public_path__ + "static/media/Snd1.aef05b9a.mp3";